import Swiper from "swiper";
import { Pagination, Navigation } from "swiper/modules";
Swiper.use([Pagination, Navigation]);

(function () {
  const mbThreeColsTextSlider = document.querySelectorAll(
    ".three-cols-text-slider"
  );
  let threeColsTextSwiper = [];

  for (let i = 0; i < mbThreeColsTextSlider.length; i++) {
    threeColsTextSwiper[i] = new Swiper(mbThreeColsTextSlider[i], {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 30,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 3,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  }
})();
